import {DG_Format_Money} from "../../../../format/money";
import React from "react";

const styleColor = {
    color: "#344054",
    fontsize: 12,
    fontWeight: 400
}
export const mapMoneyListMobile = (value) => {

    return (
        <>
            <span style={styleColor}> {DG_Format_Money(value)} <span className={"italic"}>(VNĐ)</span> </span>
        </>
    )

}
